import { ThingIt } from "@thing-it/client-api";

/**
 * Broadcast user interaction to ThingIt parent page
 */
export default () => {
  window.onload = broadcast;
  // window.onmousemove = resetTimer;
  // window.onmousedown = resetTimer;
  window.ontouchstart = broadcast;
  window.ontouchmove = broadcast;
  window.onclick = broadcast;
  window.onkeydown = broadcast;
  window.addEventListener("scroll", broadcast, true);
  const thingItInstance = new ThingIt();

  function broadcast() {
    thingItInstance.broadcastUserInteraction();
  }
};
